import { orderBy } from "lodash";
import {
  GET_COUPONS,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SHOW_MESSAGE,
  SET_ORDER_BY,
  SET_SORT_BY,
  GET_BLOGS_CATEGORY,
  GET_BLOGS,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getBlogs = () => {
  return (dispatch, getState) => {
    const state = getState().blogs;
    // console.log('Fetching blogs - Current state:', state);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(
        `/blog/list-blog?searchText=${state.search}&page=${state.page}&limit=10&sort=${state.orderby}&sortBy=${state.sortby}`
      )
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          
          // console.log('Blog list API response structure:', {
          //   blogs: data.data.blogs,
          //   categoryData: data.data.blogs?.map(blog => ({
          //     id: blog._id,
          //     category: blog.categoryId
          //   }))
          // });
          // console.log('Blog list API response:', data.data);
          dispatch({
            type: GET_BLOGS,
            payload: data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addBlogs = (payload, closeModel, form) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    // console.log("payload: ", payload);
    jwtAxios
      .post("/blog/add-blog", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Blog added successfully",
          });
          closeModel();
          form.resetFields();
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editBlogs = (payload, id, closeModel) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put(`blog/edit-blog/${id}`, payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Blog updated successfully",
          });
          closeModel();
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteBlog = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .delete(`/blog/delete-blog/${id}`)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Blog deleted successfully",
          });
          dispatch(getBlogs());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const getBlogCategory = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    // console.log('Fetching blog categories...');
    jwtAxios
      .get("/coupon/getAllCategories")
      .then((data) => {
        // console.log('Blog categories API response:', data);
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS }); 
          dispatch({
            type: GET_BLOGS_CATEGORY,
            payload: data.data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
